import React from 'react';
import classNames from 'classnames';

import { BreadcrumbsV2, DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { TaxonomyExpertise } from '../../../../types/uncinc_profile/taxonomy';
import { ParagraphsRenderer } from '../../../../components';

import './style.scss';

interface ExpertiseProps {
  entity: ImmutableEntity<TaxonomyExpertise>;
  className?: string;
}

const TaxonomyExpertisePage: React.FC<ExpertiseProps> = ({ entity, className }) => {
  const classes = classNames('Taxonomy', 'TaxonomyExpertise', className);

  const expertise = entity.toJS();
  const title = expertise.name[0].value;
  const body = expertise.description[0]?.processed;
  const media = expertise.field_media_item[0];
  const caption = media?.entity.field_caption[0]?.value;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="TaxonomyExpertise__hero">
        <Container>
          <div className="row">
            <div className="col-12">
              <BreadcrumbsV2 showHomeIcon={false} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-10">
              <h1 className="TaxonomyExpertise__title" itemProp="title">
                {title}
              </h1>

              {body && (
                <WysiwygField
                  className="TaxonomyExpertise__body body--large"
                  property="schema:text"
                  html={body}
                />
              )}
            </div>
            {media && (
              <div className="col-12">
                <div className="TaxonomyExpertise__media-wrapper">
                  <DynamicMediaItem
                    className="TaxonomyExpertise__media"
                    media={media}
                    imageAspectRatio="2_1"
                    aboveTheFold
                  />
                </div>
                {/* We render the caption outside, to prevent layout shifting */}
                {caption && (
                  <p className="caption">{caption}</p>
                )}
              </div>
            )}
          </div>
        </Container>
      </div>

      <ParagraphsRenderer
        className="TaxonomyExpertise__paragraphs"
        paragraphs={entity.get('field_paragraphs')}
        isWide
      />
    </article>
  );
};

export default TaxonomyExpertisePage;
